import InputField from '../Forms/InputField';

export default function SocialMediaDetails({ socialFields, setSocialFields }) {

    const handleChange = (index, newValue) => {
        setSocialFields(prevFields =>
            prevFields.map((field, i) =>
                i === index ? { ...field, value: newValue } : field
            )
        );
    };

    return (
        <section className="flex flex-col self-stretch font-semibold max-md:max-w-full">
            <div className="flex flex-col justify-center px-5 bg-white rounded-md shadow-[0px_4px_25px_rgba(94,92,154,0.1)] max-md:max-w-full py-3">
                {socialFields.map((field, index) => (
                    <div key={index} className="flex flex-wrap gap-3 w-full">
                        <InputField
                            label={field.label}
                            placeholder={field.placeholder}
                            value={field.value}
                            onChange={e => handleChange(index, e.target.value)}
                        />
                    </div>
                ))}
            </div>
        </section>
    );
}